import comp from "./ModalFooter";
export default comp;
